import React from "react";
import { Helmet } from "react-helmet";
import LiveHeader from "../common/LiveHeader";
import LiveRdcPoweredBy from "./LiveRdcPoweredBy";
import howItWorks1 from "./images/how-it-works-1.png";
import howItWorks2 from "./images/how-it-works-2.png";
import howItWorks3 from "./images/how-it-works-3.png";
import {
  Container,
  Description,
  PoweredByContainer,
  SubTitle,
  Text,
  TextTitle,
  Title
} from "./styled/live-rdc";
import {
  Cell,
  CellHeader,
  Grid,
  HowItWorks,
  Image
} from "./styled/live-rdc-listing-promotion";

function LiveRdcListingPromotion() {
  return (
    <>
      <Helmet>
        <title>Listing Promotion</title>
      </Helmet>
      <LiveHeader>Listing Promotion</LiveHeader>
      <Container>
        <Title>
          Why is Realtor.com®'s Listing Promotion valuable for your property?
        </Title>
        <Description>
          As your agent, I could leverage my access to this premium service via
          Realtor.com® and it's included in the premium services I invest in for
          my clients. Promoting your listing on Realtor.com® could be part of
          the marketing strategy we set for selling your property. Listing
          promotion can help increase buyer interest in a property and help lead
          to faster awareness among buyers and greater exposure for
          harder-to-sell homes.
        </Description>
        <TextTitle>
          How does Realtor.com®'s Listing Promotion help your property?
        </TextTitle>
        <Text>
          Listing Promotion on Realtor.com® helps your property stay top of mind
          during relevant buyer searches to help drive more interest. Promotion
          increases the likelihood that active buyers will find your property's
          listing as it will sit at the top of relevant search results..
        </Text>
        <HowItWorks>
          <SubTitle>How it works</SubTitle>
          <Grid>
            <Cell>
              <Image
                src={howItWorks1}
                alt="Listing promotion launches to help maximize exposure"
              />
              <CellHeader>
                <Text strong>
                  Listing promotion launches to help maximize exposure
                </Text>
              </CellHeader>
              <Text small>
                Promotion runs for a specified duration in your property's
                target market on Realtor.com®.
              </Text>
            </Cell>
            <Cell>
              <Image
                src={howItWorks2}
                alt="Listing is featured to buyers in your market"
              />
              <CellHeader>
                <Text strong>Listing is featured to buyers in your market</Text>
              </CellHeader>
              <Text small>
                Your listing will be among the four featured listings on the
                first page of Realtor.com® relevant search results for its
                designated markets.
              </Text>
            </Cell>
            <Cell>
              <Image
                src={howItWorks3}
                alt="Receive regular performance reports"
              />
              <CellHeader>
                <Text strong>Receive regular performance reports</Text>
              </CellHeader>
              <Text small>
                Reports on how your listing is performing will be regularly
                shared with you by email.
              </Text>
            </Cell>
          </Grid>
        </HowItWorks>
        <PoweredByContainer>
          <LiveRdcPoweredBy />
        </PoweredByContainer>
      </Container>
    </>
  );
}

export default LiveRdcListingPromotion;
